import { render, staticRenderFns } from "./PurchaseEdit.vue?vue&type=template&id=4666c74b&"
import script from "./PurchaseEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports